var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"700px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.src != null)?_c('v-card',[_c('v-img',{attrs:{"src":_vm.src,"aspect-ratio":"1","contain":""}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }